<template>
  <div class="phenotype-more-dialog col-block width-full">
    <div class="phenotype-more-title-container col-block flex-start">
      <div class="phenotype-more-title">{{ $t('LAYOUT.dialog.phenotypeMore.___title') }}</div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="phenotype-more-table-container col-block width-full">
      <div
        class="phenotype-more-table-block"
        :style="{
          flex: 1,
          'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr'
        }"
      >
        <div
          class="phenotype-more-table-content-container col-block width-full"
          v-for="(option, toindex) in tableOptions"
          :key="toindex"
          :class="option.class"
          :style="{
            'grid-column': 'span ' + option.grid
          }"
        >
          <div class="phenotype-more-table-head-container col-block width-full">
            <div class="phenotype-more-table-head-block col-block width-full">
              <div class="phenotype-more-table-head">{{ option.title }}</div>
            </div>
          </div>
          <div class="phenotype-more-table-body-container col-block width-full">
            <template v-if="option.value === '_HPO'">
              <div class="phenotype-more-table-network-container" :style="{ flex: 1, 'max-height': (windowHeight / 2) + 'px', 'min-height': (windowHeight / 4) + 'px' }">
                <phenotypeDiseaseNetwork
                  :hpoNetworks="data.hpo_network"
                  :style="{ width: '550px' }"
                ></phenotypeDiseaseNetwork>
              </div>
            </template>
            <template v-else>
              <div class="phenotype-more-table-body-block col-block width-full">
                <div class="phenotype-more-table-body">{{ data[option.value] }}</div>
              </div>
            </template>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div> 
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="phenotype-more-button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="main-button2 circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___back') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import phenotypeDiseaseNetwork from '../../components/phenotypeDisease/network.vue'
import responsitive from '../../mixins/responsitive.vue'

export default {
  components: {
    phenotypeDiseaseNetwork
  },
  mixins: [
    responsitive
  ],
  props: {
    param: {
      type: Object,
      required: true
    }
  },
  computed: {
    // static
    tableOptions () {
      return [
        {
          title: this.$t('PAGE.phenotypeDisease.table.title.___gene'),
          value: 'gene',
          grid: 2,
          class: 'center'
        },
        {
          title: this.$t('PAGE.phenotypeDisease.table.title.___disease'),
          value: 'disease_name',
          grid: 7
        },
        {
          title: this.$t('PAGE.phenotypeDisease.table.title.___phenotype'),
          value: '_HPO',
          grid: 9
        }
      ]
    },
    // global
    data () {
      return this.param.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/phenotypeMore.vue